import React, { Suspense } from 'react'
import LogoLoader from '../Loaders/LogoLoader'

const LazyLoading = ({ children }) => {
   return (
      <Suspense fallback={<LogoLoader />} >
         {children}
      </Suspense>
   )
}

export default LazyLoading
